import {TooltipPosition} from "intro.js/src/core/steps";

export const TOUR_DATA = [

    {
        element: '#step1',  // The selector of the element you want to highlight
        intro: "Summarizes your plan details, including subscription type, expiration dates, and any important account updates. This section ensures you’re always informed about your membership status.",
        title: 'Account Status',
        position: 'top' as TooltipPosition

    },
    {
        element: '#step2',
        intro: "This section shows certifications with the shortest time left before expiration, helping you prioritize renewals or actions to keep your certifications up to date.",
        title: 'Approaching Expiration: Coming Up Soon'
    },
    {
        element: '#step3',
        intro: "This section displays the total count of both active and expired certifications, giving you an overview of your certification status.",
        title: 'Number of Certifications'
    },
    {
        element: '#step4',
        intro: "This section displays certifications with more time remaining before expiration, giving you a window to plan and complete any necessary actions or renewals.",
        title: 'Approaching Expiration: You Have Time'
    },
    {
        element: '#step5',
        intro: "Focuses on time-sensitive actions, such as certifications nearing their expiration date, upcoming renewal deadlines, or pending tasks that require immediate attention.",
        title: 'Reminders'
    },
    {
        element: '#step8',
        intro: "Provides access to upcoming CEU opportunities (i.e., courses, events, webinars, etc.) for you to choose to help meet your CEU quota. This section ensures you're always have options to earn new credits",
        title: 'Upcoming CEU Training',
        position: 'bottom"' as TooltipPosition,
        tooltipClass: 'sp-intro'
    },
    {
        element: '#step6',
        intro: "Tracks the required credits (e.g., CPEs/CEUs) for maintaining certifications.",
        title: 'Target Credits Needed',
        position: 'bottom"' as TooltipPosition,
        tooltipClass: 'sp-intro'
    },
    {
        element: '#step7',
        intro: "All Cyber Combine participants can track and manage their skill performances here",
        title: 'Cyber Combine: Scorecard',
    }
];